import { DocumentNode, gql } from "@apollo/client/core"
import { queryfy } from "./api"
// import { Query, AllTypes, Type, Variables, ObjectType } from '@/store/modules/introspection'

export function generateSimpleQuery(nameOfQuery: string, fields: Array<string>, params?: {[key: string]: any}): DocumentNode {
    const finalFields = fields.join()
    const entries = Object.entries(params || {})
    let paramsPart = ""
    if (entries.length) {
        const entriesPart = entries.filter((entry) => !!entry[1]).map((entry) => {
            const entryValue = Array.isArray(entry[1])
                ? JSON.stringify(entry[1])
                : (typeof entry[1] === "string" ? `"${entry[1]}"` : entry[1])
            return `${entry[0]}: ${entryValue}`
        }).join(", ")
        paramsPart = entriesPart ? `(${entriesPart})` : ""
    }
    const finalQuery = `query ${nameOfQuery} {
        ${nameOfQuery} ${paramsPart} {
            ${finalFields}
        }
    }`
    return gql(finalQuery)
}

export function generateSimpleIListQuery(nameOfQuery: string, fields: Array<string>, params?: {[key: string]: any}): DocumentNode {
    const finalFields = fields.join()
    const entries = Object.entries(params || {})
    let paramsPart = ""
    if (entries.length) {
        const entriesPart = entries.filter((entry) => !!entry[1]).map((entry) => {
            const entryValue = Array.isArray(entry[1])
                ? JSON.stringify(entry[1])
                : (typeof entry[1] === "string" ? `"${entry[1]}"` : entry[1])
            return `${entry[0]}: ${entryValue}`
        }).join(", ")
        paramsPart = entriesPart ? `(${entriesPart})` : ""
    }
    const finalQuery = `query ${nameOfQuery} {
        ${nameOfQuery} ${paramsPart} {
            items { ${finalFields}}, count
        }
    }`
    return gql(finalQuery)
}

// export function generateMutation(nameOfMutation: string, variables: {[key: string]: any}, fields: string[]): DocumentNode {
//     const finalTypeOfVariables = JSON.stringify(variables)
//     const finalFields = fields.join()
//     const finalQuery = gql`mutation ${nameOfMutation} (${nameOfMutation}Input: ${finalTypeOfVariables}) {
//         ${finalFields}
//     }`
//     return finalQuery
// }

export function generateMutation(nameOfMutation: string, variables: {[key: string]: any}, fields: string[], opts?: {varQuery?: string}): DocumentNode {
    const finalTypeOfVariables = queryfy(variables)
    const inputVariableName = `${nameOfMutation}Input`
    const finalFields = fields.join(", ")
    const finalQuery = `mutation {
        ${nameOfMutation} (${opts?.varQuery || `${nameOfMutation}Input: ${finalTypeOfVariables}`}) ${finalFields && '{'}
                ${finalFields}
            ${finalFields && '}'}
        }`
    // const finalQuery = `mutation ${nameOfMutation} ($${inputVariableName}: {$name: !String}) {
    //     ${nameOfMutation}(${inputVariableName}: $${inputVariableName}) {
    //         ${finalFields}
    //     }
    // }`;
    console.log("generateMutation", {finalQuery, finalFields, inputVariableName})
    return gql`${finalQuery}`
}

export function generateSimpleMutation(nameOfMutation: string, varName: string, value: string): DocumentNode {
    const finalQuery = `mutation {
        ${nameOfMutation} (${varName}: "${value}") 
        }`
    return gql`${finalQuery}`
}
